const SettingsSection = ({ label, children }) => (
  <div>
    <p className="px-4 mb-2 text-xs font-medium tracking-wider text-gray-500 uppercase">
      {label}
    </p>
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden divide-y divide-gray-100">
      {children}
    </div>
  </div>
);

export default SettingsSection;
